/* Shared identity and word matching for every CAQA search surface. */
(function(global){
 'use strict';
 const normal=s=>String(s||'').toLowerCase().replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();
 const codeOf=s=>String(s||'').match(/\b(?:[A-Z]{2,12}\d{3,8}[A-Z]{0,2}|\d{5}(?:NAT|VIC))\b/i)?.[0]?.toUpperCase()||'';
 function kindOf(p){
  if(p.kind)return p.kind;
  const code=p.code||codeOf(p.title),title=normal(p.title);
  if(!code)return 'other';
  if(/^VU\d{5}$/.test(code))return 'unit';
  if(/\bskill set\b/.test(title)||/^[A-Z]{2,5}SS\d+$/.test(code))return 'skillset';
  if(/\b(certificate|diploma)\b/.test(title))return 'qualification';
  if(/^\d{5}(NAT|VIC)$/.test(code))return 'course';
  return 'unit';
 }
 const aliases={
  'Learning and Assessment Kit':'learning assessment resources complete kit training materials',
  'Learner Resources':'learner resources learning materials',
  'Assessment Kit':'assessment kit assessment tools assessor resources',
  'RPL Kit':'rpl kit recognition prior learning assessment',
  'LLND Kit':'llnd language literacy numeracy digital assessment',
  'LLN Kit':'lln language literacy numeracy assessment',
  'SCORM':'scorm elearning e learning lms online learning package',
  'PowerPoint':'powerpoint slides presentation',
  'Session Plan':'session plan lesson plan',
  'Class Activity Book':'class activity book classroom activities',
  'Self-Study Guide':'self study guide independent learning',
  'Unit Knowledge Guide':'unit knowledge guide',
  'Vocational Placement Kit':'vocational workplace placement kit logbook',
  'Training and Assessment Strategy':'tas training assessment strategy template',
  'ERF Checklist':'erf equipment resources facilities checklist',
  'Learner Guide':'learner guide student guide',
  'Policies and Procedures':'policies procedures organisational documentation',
  'Forms':'form forms template',
  'ELICOS Resources':'elicos english language teaching resources',
  'Professional Development':'professional development webinar',
  'Compliance Resources':'compliance documentation resource'
 };
 const knownFormats=new Set(Object.keys(aliases)),stop=new Set(['rto','resources','resource','products','product','and','the','for','of','a','an','to']);
 const corrections={'first aide':'first aid','assesment':'assessment','assesments':'assessments','assesssment':'assessment','managment':'management','leadreship':'leadership','resusitation':'resuscitation','requirments':'requirements','andremoval':'and removal','hazardousmaterials':'hazardous materials','servicess':'services','toplogy':'topology','processs':'processes','anddesoldering':'and desoldering','enquiriess':'enquiries','arrearss':'arrears','exoperiences':'experiences','pasteries':'pastries','proces':'process','demolitionrecyclable':'demolition recyclable','usingload':'using load'};
 function interpretation(params){
  const get=k=>params instanceof URLSearchParams?params.get(k):params[k];
  const original=String(get('q')||'').trim();let query=normal(original),correction='',inferredFormat='';
  for(const [wrong,right] of Object.entries(corrections)){
   const next=query.replace(new RegExp('(^| )'+wrong+'(?= |$)','g'),(_,lead)=>lead+right);
   if(next!==query){query=next;correction=query;}
  }
  if(['recognition of prior learning','rpl kits','rpl kit','rpl'].includes(query)){inferredFormat='RPL Kit';query='';}
  else if(['llnd','llnd kits'].includes(query)){inferredFormat='LLND Kit';query='';}
  else if(['lln','lln kits'].includes(query)){inferredFormat='LLN Kit';query='';}
  if(query==='cpr')query='cardiopulmonary resuscitation';
  const compact=query.replace(/\s/g,'').toUpperCase();
  const code=/^(?:[A-Z]{2,12}\d{2,8}[A-Z]{0,2}|\d{5}(?:NAT|VIC))$/.test(compact)?compact:codeOf(query);
  return {original,query,code,inferredFormat,correction,expandedCPR:normal(original)==='cpr'};
 }
 function select(items,params){
  const get=k=>params instanceof URLSearchParams?params.get(k):params[k],info=interpretation(params);
  let q=info.query,kind=get('kind')||'',stock=get('availability')||'';
  if(!stock&&/\bpre[-\s]?order\b/i.test(q)){stock='preorder';q=q.replace(/\bpre[-\s]?order\b/ig,'');}
  q=q.replace(/tag:(Unit|Qualification)/ig,(_,v)=>{kind=v.toLowerCase();return '';}).replace(/\*/g,'');
  let industry=(get('industry')||'').toUpperCase();const candidate=q.trim().toUpperCase();
  if(!industry&&/^[A-Z]{2,5}(?:\d{2})?$/.test(candidate)&&candidate!=='CPR'&&(candidate==='NAT'||items.some(p=>p.packages?.includes(candidate)||(p.code||codeOf(p.title)).startsWith(candidate)))){industry=candidate;q='';}
  const skuIds=new Set(info.original?items.filter(p=>(p.skus||[]).some(s=>normal(s)===normal(info.original))).map(p=>p.id):[]);
  const knownCandidate=info.code&&items.some(p=>(p.code||codeOf(p.title)).startsWith(info.code));
  const wanted=!skuIds.size&&info.code&&(codeOf(info.original)||knownCandidate||!/[\s-]/.test(info.original))?info.code:'';
  const exact=!!wanted&&items.some(p=>(p.code||codeOf(p.title))===wanted);
  if(skuIds.size)q='';
  if(wanted){const compact=normal(q).replace(/ /g,'');q=compact===normal(wanted)?'':normal(q).replace(normal(wanted),'').trim();}
  const tokens=normal(q).split(' ').filter(t=>t&&!stop.has(t)),type=get('filter.p.product_type')||get('format')||info.inferredFormat||'';
  const min=get('filter.v.price.gte')||get('min')||'',max=get('filter.v.price.lte')||get('max')||'';
  return items.filter(p=>{
   const code=p.code||codeOf(p.title);
   if(skuIds.size&&!skuIds.has(p.id))return false;
   if(wanted&&(exact?code!==wanted:!code.startsWith(wanted)))return false;
   if(type&&(type==='__other'?knownFormats.has(p.type):p.type!==type))return false;
   if(industry&&!(p.packages?.includes(industry)||code.startsWith(industry)||(industry==='NAT'&&/NAT$/.test(code))))return false;
   if(kind&&kindOf(p)!==kind)return false;
   if(stock&&!(stock==='ready'?p.available&&p.ready&&!p.preorder:stock==='preorder'?p.preorder:stock==='confirm'?p.available&&!p.ready&&!p.preorder:!p.available&&!p.preorder))return false;
   if((min!==''||max!=='')&&p.preorder)return false;
   if((min!==''&&p.price<Number(min)*100)||(max!==''&&p.price>Number(max)*100))return false;
   if(!tokens.length)return true;
   if(!p._words){const position=code?String(p.title).toUpperCase().indexOf(code):-1;const subject=normal(position>=0?String(p.title).slice(position+code.length):p.title);p._subject=subject.trim();p._words=normal(subject+' '+p.type+' '+(aliases[p.type]||'')+' '+(p.aliases||[]).join(' ')).split(' ').filter(Boolean);}
   return (p.skus||[]).some(s=>normal(s)===normal(info.original))||tokens.every(t=>p._words.some(word=>word===t||word.startsWith(t)));
  }).map(p=>{
   if(!tokens.length||wanted)return p._queryRank?{...p,_queryRank:0}:p;
   const phrase=tokens.join(' '),subject=p._subject||'';
   const score=subject===phrase?0:subject.includes(phrase)?1:tokens.every(t=>subject.split(' ').includes(t))?2:3;
   return {...p,_queryRank:score};
  });
 }
 const api={normal,codeOf,kindOf,select,interpretation,aliases};
 if(typeof module==='object'&&module.exports)module.exports=api;
 else{global.CAQA=global.CAQA||{};global.CAQA.searchMatching=api;}
})(typeof window==='undefined'?globalThis:window);
